import { ContextMenu, ContextEnumItemGroup, ContextEnumItem } from '../../BaseShape/ContextMenu';

export class CommentContextMenu extends ContextMenu {
  constructor(cell?: any, evtTarget?: any, data?: any) {
    super();
    const content = new Array<ContextEnumItemGroup>();
    this.set('hasEditGroup', true);

    this.set('content', content);
  }
}
